﻿import { Component, Show, createMemo } from "solid-js";

export interface LocationData {
  name: string | null;
  label: string | null;
  address: string | null;
  visitingAddress: string | null;
  postalAddress: string | null;
  facsimileNumbers: string[] | null;
  externalLink: string | null;
  latitude: number | null;
  longitude: number | null;
  phoneNumber: string | null;
}

interface LocationCardProps {
  location: LocationData;
}

export const LocationCard: Component<LocationCardProps> = (props) => {
  const hasFacsimileNumbers = createMemo(() => {
    const length = props.location.facsimileNumbers?.length ?? 0;

    return length > 0;
  });

  function handleMobileDesktopClick(event: Event) {
    // Preventing the popup block to come up- on site with event with the last else '_blank'
    event.preventDefault();
    // Function that opens the app if the user is on Android or IOS
    const userAgent = navigator.userAgent.toLowerCase();

    if (/iphone|ipad|ipod/.test(userAgent)) {
      // User is using iOS
      window.location.href = `maps://maps.google.com/maps?q=${props.location.externalLink}`;
    } else if (/android/.test(userAgent)) {
      // User is using Android
      window.location.href = `geo:0,0?q=${props.location.externalLink}`;
    } else {
      // User is using a different device, desktop etc...
      window.open(`http://maps.google.com/maps?q=${props.location.externalLink}`, '_blank');
    }
  }

  return (
    <div class="flex flex-col p-6 w-full bg-white gap-6 sm:flex-row lg:min-h-[200px]">
      <div class="flex-auto space-y-2">
        <Show when={props.location.label}>
          <span class="inline-block ml-auto px-4 py-2 text-m-h5 font-sans text-grayscale-900 bg-secondary-lblue lg:text-h6">
            {props.location.label?.toUpperCase()}
          </span>
        </Show>
        <h4 class="font-semibold text-m-lg text-grayscale-900 lg:font-semibold lg:text-lg">
          {props.location.address}
        </h4>
        <Show when={props.location.phoneNumber}>
          <p class="text-m-sm text-grayscale-600 lg:text-sm">
            {props.location.phoneNumber}
          </p>
        </Show>

        <Show when={hasFacsimileNumbers()}>
          <p class="text-m-sm text-grayscale-600 lg:text-sm">
            <strong class="font-bold">Fax:</strong>{" "}
            {props.location.facsimileNumbers?.join(", ")}
          </p>
        </Show>

        <Show when={props.location.visitingAddress}>
          <p class="text-m-sm text-grayscale-600 lg:text-sm">
            <strong class="font-bold">Besöksadress:</strong>{" "}
            {props.location.visitingAddress}
          </p>
        </Show>

        <Show when={props.location.postalAddress}>
          <p class="text-m-sm text-grayscale-600 lg:text-sm">
            <strong class="font-bold">Postadress:</strong>{" "}
            {props.location.postalAddress}
          </p>
        </Show>

        <Show when={props.location.externalLink}>
          <p>
          <a
            href={
              "http://maps.apple.com/?q=" + props.location.externalLink ??
              undefined
            }
            target="_blank"
            onclick={handleMobileDesktopClick}
            class="text-m-sm text-secondary-blue lg:text-sm hover:text-primary active:text-secondary-blue focus-visible:text-secondary-blue focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary-blue"
          >
            <strong class="font-bold underline">
              Hitta hit
              <svg
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                class="inline-block h-5 w-5 align-baseline ml-1"
                role="img"
              >
                <path
                  d="M18 13.38v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2h6"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15 3.38h6v6m-11 5 11-11"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>{" "}
            </strong>
          </a>
          </p>
        </Show>
      </div>
    </div>
  );
};

export default Location;
